import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import styled from 'styled-components'

import { selectDevice } from 'hooks/deviceInfo'
import { useSelector } from 'react-redux'
import { timerAlert } from 'util/util'

import { useSpring, animated, useTransition } from '@react-spring/web'

import Bg from 'assets/img/cps/volly/Volleyball_BG.png'
import Volleyball_Speed from 'assets/img/cps/volly/Volleyball_Speed.png'
import Volleyball_Cusion from 'assets/img/cps/volly/Volleyball_Cusion.png'
import Volleyball_Stability from 'assets/img/cps/volly/Volleyball_Stability.png'
import TennisAllCourt from 'assets/img/cps/tennisAllCourt.png'
import TennisBaseline from 'assets/img/cps/tennisBaseline.png'
import TennisBestOfBoth from 'assets/img/cps/tennisBestOfBoth.png'

import { apiSaveLog, apiThumbnailList } from 'api/api'

import NavigateButton from 'components/NavigateButton'

const Container = styled.div`
	background-image: url(${Bg});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	padding: 35px 67px;
	position: relative;
`

const MenuContainer = styled.div`
	position: relative;
	padding-top: calc(220px - 55px);
	.itemInner {
		display: flex;
		justify-content: space-between;
		align-items: top;
	}
	.itemContainer {
		position: relative;
		width: 557px;
		height: 718px;
		padding-top: 340px;
		display: flex;
		&.i1 {
			position: absolute;
			left: 0;
			background-image: url(${Volleyball_Speed});
		}
		&.i2 {
			position: absolute;
			left: 620px;
			background-image: url(${Volleyball_Cusion});
		}
		&.i3 {
			position: absolute;
			left: 1230px;
			background-image: url(${Volleyball_Stability});
		}
	}
	.listItem {
		list-style: none;
		padding: 0;
		margin: 0;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		li {
			width: 50%;
			height: 180px;
			padding: 0 10px;
			img {
				max-width: 100%;
			}
		}
	}
`

const PageTitle = styled.div`
	position: absolute;
	top: 60px;
	left: 60px;
	font-size: 40px;
	color: #494949;
	width: 210px;
	text-align: center;
	line-height: 1;
	.bar {
		width: 100%;
		height: 10px;
		background: #515151;
		margin: 15px 0;
	}
	span {
		font-size: 55px;
	}
`

const VollyBallList = () => {
	const location = useLocation()
	const deviceInfo = useSelector(selectDevice)
	const navigate = useNavigate()

	const [baseLineList, setBaseLineList] = useState<any[]>([])
	const [allCourtList, setAllCourtList] = useState<any[]>([])
	const [bestOfBothList, setBestOfBothList] = useState<any[]>([])

	const menuMove1 = useSpring({
		from: { opacity: 0, y: 0 },
		to: { opacity: 1, y: 0 },
		delay: 100,
	})

	const menuMove2 = useSpring({
		from: { opacity: 0, y: 0 },
		to: { opacity: 1, y: 0 },
		delay: 200,
	})

	const menuMove3 = useSpring({
		from: { opacity: 0, y: 0 },
		to: { opacity: 1, y: 0 },
		delay: 300,
	})

	const titleMove = useSpring({
		from: { opacity: 0, x: -0 },
		to: { opacity: 1, x: 0 },
		delay: 0,
	})

	const titleMove2 = useSpring({
		from: { opacity: 0, x: 0 },
		to: { opacity: 1, x: 0 },
		delay: 0,
	})

	const onItemClick = (item: any, itemType: any) => {
		item.subsortId = location.state.item.subsortId
		item.pageTitle = itemType
		item.subPageTItle = location.state?.item?.title

		const logRequest = {
			userId: deviceInfo.userId,
			kioskDeviceId: deviceInfo.kioskDeviceId,
			categoryId: deviceInfo.categoryId,
			productId: item.productId,
			subSortId: location.state?.item?.subsortId,
		}
		if (
			logRequest.userId &&
			logRequest.kioskDeviceId &&
			logRequest.categoryId &&
			logRequest.productId &&
			logRequest.subSortId
		) {
			apiSaveLog(logRequest)
		}

		navigate(`/cps/tennis/view`, { state: { item } })
	}

	useEffect(() => {
		const { item } = location.state
		console.log(item)
		if (item) {
			const request = {
				subsortId: item.subsortId,
				kioskDeviceId: deviceInfo.kioskDeviceId,
			}
			apiThumbnailList(request).then((res) => {
				console.log(res)
				// cpsCategoryId
				{
					/* subSortId가 6이면 (테니스) cpsCate1, 7이면 (배구) cpsCate2, 8이면 (트랙엔필드) cpsCate3, 12면 (기타) cpsCate4 */
				}
				// const cpsCate1 = [
				// 	{ id: 1, cate: 'STABILITY & SPEED', value: 'STABILITY & SPEED' },
				// 	{ id: 2, cate: 'STABILITY', value: 'STABILITY' },
				// 	{ id: 3, cate: 'SPEED', value: 'SPEED' },
				// ]
				// const cpsCate2 = [
				// 	{ id: 4, cate: 'SPEED', value: 'SPEED' },
				// 	{ id: 5, cate: 'CUSHION', value: 'CUSHION' },
				// 	{ id: 6, cate: 'STABILITY', value: 'STABILITY' },
				// ]
				// const cpsCate3 = [
				// 	{ id: 7, cate: 'Short Distance', value: 'Short Distance' },
				// 	{ id: 8, cate: 'Middle Distance', value: 'Middle Distance' },
				// 	{ id: 9, cate: 'Long Distance', value: 'Long Distance' },
				// ]
				// const cpsCate4 = [
				// 	{ id: 10, cate: 'INDOOR', value: 'INDOOR' },
				// 	{ id: 11, cate: 'BASKETBALL', value: 'BASKETBALL' },
				// 	{ id: 12, cate: 'WRESTLING', value: 'WRESTLING' },
				// 	{ id: 13, cate: 'WORKING', value: 'WORKING' },
				// ]
				res.forEach((element: any) => {
					if (element.cpsCategoryId === 4) {
						setBaseLineList((prev) => [...prev, element])
					} else if (element.cpsCategoryId === 5) {
						setAllCourtList((prev) => [...prev, element])
					} else if (element.cpsCategoryId === 6) {
						setBestOfBothList((prev) => [...prev, element])
					}

					// if (element.name.startsWith('GEL')) {
					// 	setBaseLineList((prev) => [...prev, element])
					// } else if (element.name.startsWith('SOL')) {
					// 	setAllCourtList((prev) => [...prev, element])
					// } else if (element.name.startsWith('COU')) {
					// 	setBestOfBothList((prev) => [...prev, element])
					// }
				})
			})
		}
		const disablePinchZoom = (e: any) => {
			if (e.touches.length > 1) {
				e.preventDefault()
			}
		}
		document.addEventListener('touchmove', disablePinchZoom, {
			passive: false,
		})
		return () => {
			document.removeEventListener('touchmove', disablePinchZoom)
		}
	}, [])

	return (
		<Container className="container">
			{/* <PageTitle>
				<animated.div style={titleMove}>
					<span className="asics-bold-italic">TENNIS</span>
				</animated.div>
			</PageTitle> */}
			<MenuContainer>
				<animated.div
					className="itemInner"
					style={menuMove1}
				>
					<div className="itemContainer i1">
						<ul className="listItem">
							{baseLineList
								.filter((item: any) => item.pdbkProductId === undefined)
								.map((item: any, index: number) => {
									return (
										<li key={item.fileId}>
											<img
												src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
												alt="heritage"
												onClick={() => onItemClick(item, 'Baseline')}
											/>
										</li>
									)
								})}
						</ul>
					</div>
					<div className="itemContainer i2">
						<ul
							className="listItem"
							style={{ width: '100%' }}
						>
							{allCourtList
								.filter((item: any) => item.pdbkProductId === undefined)
								.map((item: any, index: number) => {
									return (
										<li key={item.fileId}>
											<img
												src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
												alt="heritage"
												onClick={() => onItemClick(item, 'All-Court')}
											/>
										</li>
									)
								})}
						</ul>
					</div>
					<div className="itemContainer i3">
						<div
							style={{
								fontSize: 20,
								fontWeight: 'bold',
								lineHeight: '150px',
								width: 220,
								textAlign: 'center',
							}}
						>
							COMMING SOON
							{
								allCourtList.filter((item: any) => item.pdbkProductId === undefined)
									.length
							}
						</div>
						<ul className="listItem">
							{/* {bestOfBothList.map((item: any, index: number) => {
								return (
									<li key={item.fileId}>
										<img
											src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
											alt="heritage"
											onClick={() => onItemClick(item, 'Best of Both')}
										/>
									</li>
								)
							})} */}
						</ul>
					</div>
				</animated.div>
			</MenuContainer>
			<NavigateButton />
		</Container>
	)
}

export default VollyBallList
